































































import { ISchedule } from '@/store/modules/views/schedule/states'
import _ from 'lodash'
import moment from 'moment'
import { locale } from 'moment'
import { Vue, Prop, Component } from 'vue-property-decorator'

export interface IEventCalendar {
  _id?: string
  name: string
  start: Date
  end: Date
  color: string
  timed: boolean
  isDialog: boolean
}

@Component
export default class Calendar extends Vue {
  @Prop({ default: '' }) public header!: string
  @Prop({ default: { 'month': 'เดือน', 'week': 'สัปดาห์', 'day': 'วัน', '4day': '4 วัน' } }) public typeList!: object
  @Prop({ default: false }) public isSelected!: boolean
  @Prop({ default: false }) public isEventDialog!: boolean
  @Prop({ default: [] }) public events!: IEventCalendar[]
  @Prop() public schedule!: ISchedule

  public focus = ''
  public type = 'month'
  public eventData = {}
  public eventDialog = false
  public title = moment().locale('th').add(543, 'year').format('MMMM YYYY')
  public actionToolbar = [
    {
      name: 'วันนี้',
      class: 'mr-4 d-none d-sm-flex',
      props: {
        outlined: true,
      },
      action: this.setToday,
    },
    {
      icon: 'chevron-left',
      class: 'mr-4',
      props: {
        fab: true,
        text: true,
        small: true,
        ripple: false,
      },
      action: this.prev,
    },
    {
      icon: 'chevron-right',
      class: 'mr-4',
      props: {
        fab: true,
        text: true,
        small: true,
        ripple: false,
      },
      action: this.next,
    },
  ]

  get refs(): any {
    return this.$refs.calendar
  }

  public mounted() {
    this.$forceUpdate()
    this.refs.checkChange()
  }

  public viewDay({ date }) {
    this.focus = date
    this.type = 'day'
  }

  public getEventColor(event) {
    return event.color
  }

  public setToday() {
    this.focus = ''
  }

  public prev(event) {
    this.refs.prev()
    this.doGetTitle()
  }

  public next() {
    this.refs.next()
    this.doGetTitle()
  }

  public doClickDay(event) {
    this.doHandlerClick(event)
  }

  public doClickDate(event) {
    // const key = 'day'
    // if (this.typeList[key]) {
    //   const action = () => this.viewDay
    // }
    this.doHandlerClick(event)
  }

  public doHandlerClick(event) {
    if (this.isSelected && !this.eventDialog) {
      this.$emit('selectedDay', _.split(event.date, '-').join('-'))
    }
  }

  public doGetTitle() {
    setTimeout(() => {
      const current = (this.$refs.calendar as any).lastStart.date
      this.title = moment(current).locale('th').add(543, 'year').format('MMMM YYYY')
    }, 10)
  }

  public doSaveSchedule(data) {
    if (this.schedule) {
      const found = _.find(this.schedule, { _id: data.event._id })
      if (this.isEventDialog) {
        this.eventData = found
        this.eventDialog = data.event.isDialog
      } else {
        if (found) {
          const key = 'scheduleView'
          localStorage[key] = JSON.stringify(found)
          this.$router.push('/action/today')
        }
      }
    }
  }
}
